// extracted by mini-css-extract-plugin
module.exports = {"display":"TechStack_display__3Jkio","price":"TechStack_price__3CCBx","btn_begin":"TechStack_btn_begin__1Ew8Y"};